import React, { useEffect, useState } from 'react';
import BrowserFrame from './BrowserFrame';

const fullAnswer =
  "D'après les 3 derniers rapports trimestriels, le CA a progressé de 28 % sur le Q3. La croissance provient principalement du segment enterprise.";

const AIAssistant: React.FC = () => {
  const [typed, setTyped] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setTyped((t) => (t >= fullAnswer.length ? 0 : t + 2));
    }, 60);
    return () => clearInterval(id);
  }, []);

  const answerPart = fullAnswer.slice(0, typed);

  return (
    <BrowserFrame url="miid.app/assistant">
      <div style={{ padding: '1rem', background: 'var(--cream)', minHeight: '260px', fontFamily: "'Montserrat', sans-serif" }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '.8rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
            <div style={{ width: '22px', height: '22px', background: 'linear-gradient(135deg, var(--blue), #5E35B1)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '.6rem', fontWeight: 700 }}>✦</div>
            <div style={{ fontSize: '.72rem', fontWeight: 600, color: 'var(--ink)' }}>Assistant IA · Base doc interne</div>
          </div>
          <div style={{ fontSize: '.48rem', color: 'var(--ink2)', padding: '.12rem .4rem', background: 'var(--blue-pale)', borderRadius: '2px', fontWeight: 600 }}>LLM · RAG</div>
        </div>

        {/* User message */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '.6rem' }}>
          <div style={{ background: 'var(--blue)', color: 'white', padding: '.5rem .7rem', borderRadius: '10px 10px 2px 10px', maxWidth: '75%', fontSize: '.62rem', lineHeight: 1.5 }}>
            Quelle est la progression du CA au dernier trimestre ?
          </div>
        </div>

        {/* AI answer */}
        <div style={{ display: 'flex', gap: '.5rem', alignItems: 'flex-start', marginBottom: '.6rem' }}>
          <div style={{ width: '22px', height: '22px', background: 'linear-gradient(135deg, var(--blue), #5E35B1)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '.6rem', fontWeight: 700, flexShrink: 0 }}>✦</div>
          <div style={{ flex: 1 }}>
            <div style={{ background: 'var(--white)', border: '1px solid var(--border)', padding: '.55rem .7rem', borderRadius: '2px 10px 10px 10px', fontSize: '.62rem', lineHeight: 1.6, color: 'var(--ink)' }}>
              {answerPart}
              <span style={{ display: 'inline-block', width: '2px', height: '.7rem', background: 'var(--blue)', marginLeft: '1px', verticalAlign: 'middle', animation: 'caret 1s steps(2) infinite' }} />
            </div>

            {/* Sources */}
            <div style={{ display: 'flex', gap: '.3rem', marginTop: '.4rem', flexWrap: 'wrap' }}>
              {[
                { n: 1, label: 'Rapport Q3-2024.pdf' },
                { n: 2, label: 'Segments_Enterprise.xlsx' },
                { n: 3, label: 'Board_deck_Oct.pptx' },
              ].map((s) => (
                <div key={s.n} style={{ display: 'inline-flex', alignItems: 'center', gap: '.25rem', padding: '.15rem .35rem', background: 'var(--white)', border: '1px solid var(--border)', borderRadius: '2px', fontSize: '.45rem', color: 'var(--ink2)' }}>
                  <span style={{ background: 'var(--blue-pale)', color: 'var(--blue)', width: '11px', height: '11px', borderRadius: '50%', fontSize: '.4rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{s.n}</span>
                  {s.label}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Input */}
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: '20px', padding: '.4rem .7rem', display: 'flex', alignItems: 'center', gap: '.4rem', marginTop: '.5rem' }}>
          <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
            <path d="M7 1v12M1 7h12" stroke="var(--ink2)" strokeWidth="1.3" strokeLinecap="round" />
          </svg>
          <div style={{ flex: 1, fontSize: '.58rem', color: 'var(--ink2)' }}>Poser une question sur vos documents…</div>
          <div style={{ width: '22px', height: '22px', background: 'var(--blue)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 6h8M6 2l4 4-4 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" /></svg>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
};

export default AIAssistant;
